export default __webpack_public_path__ + "static/media/API.3799ebbe.jpg";